module.exports = __webpack_public_path__ + "img/profile.7b28486a.jpg";